import { c as _c } from "react/compiler-runtime";
import { Switch } from "@website/ui/switch";
import { numberConvert } from "@website/utils/number-convert";
import { times } from "./times.constant";
interface Properties {
  title: string;
  desc: string;
  switchValue: string;
  selectedValues: Array<string>;
  onChange: (values: Array<string>) => void;
}
export function TourFilterRoomTimeRow(t0) {
  const $ = _c(30);
  const {
    title,
    desc,
    switchValue,
    selectedValues,
    onChange
  } = t0;
  let t1;
  if ($[0] !== selectedValues || $[1] !== switchValue) {
    t1 = selectedValues.includes(switchValue);
    $[0] = selectedValues;
    $[1] = switchValue;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const isSwitchActive = t1;
  let t2;
  if ($[3] !== onChange || $[4] !== selectedValues) {
    t2 = function onToggle(t3) {
      const {
        value,
        replaceAll
      } = t3;
      return function () {
        if (replaceAll) {
          onChange(selectedValues.includes(value) ? [] : [value]);
        } else {
          onChange(selectedValues.includes(value) ? selectedValues.filter(index => index !== value) : [...selectedValues, value]);
        }
      };
    };
    $[3] = onChange;
    $[4] = selectedValues;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onToggle = t2;
  let t3;
  if ($[6] !== title) {
    t3 = <p className="text-on-surface-high-emphasis text-sm font-medium">{title}</p>;
    $[6] = title;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      maxWidth: "calc(100% - 44px)",
      fontSize: "11px"
    };
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== desc) {
    t5 = <p className="text-on-surface-medium-emphasis truncate" style={t4}>{desc}</p>;
    $[9] = desc;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== onToggle || $[12] !== switchValue) {
    t6 = onToggle({
      value: switchValue,
      replaceAll: true
    });
    $[11] = onToggle;
    $[12] = switchValue;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== isSwitchActive || $[15] !== t6) {
    t7 = <Switch checked={isSwitchActive} color="secondary" onChange={t6} className="-ml-2" />;
    $[14] = isSwitchActive;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t5 || $[18] !== t7) {
    t8 = <div className="flex w-full items-center justify-between">{t5}{t7}</div>;
    $[17] = t5;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== isSwitchActive || $[21] !== onToggle || $[22] !== selectedValues) {
    t9 = times.map(t10 => {
      const {
        icon,
        text,
        timeText,
        value: value_0
      } = t10;
      return <div key={text} className={`flex w-full cursor-pointer flex-col justify-center rounded-lg border py-2 text-center ${isSwitchActive ? "pointer-events-none [&>*]:opacity-60" : selectedValues.includes(value_0) ? "border-on-surface-secondary-medium-emphasis bg-transparent-secondary" : "border-on-surface-disable"}`} onClick={onToggle({
        value: value_0,
        replaceAll: false
      })}><p className={`text-xl ${selectedValues.includes(value_0) ? "text-on-surface-secondary-high-emphasis" : "text-on-surface-medium-emphasis"}`}>{icon}</p><p className="text-on-surface-high-emphasis pt-2 text-sm font-medium">{text}</p><p className="text-on-surface-medium-emphasis pt-1 text-xs font-normal" dir="ltr">{numberConvert(timeText, {
            locale: "fa"
          })}</p></div>;
    });
    $[20] = isSwitchActive;
    $[21] = onToggle;
    $[22] = selectedValues;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t9) {
    t10 = <div className="mt-1 flex justify-between gap-2 lg:gap-1">{t9}</div>;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t10 || $[27] !== t3 || $[28] !== t8) {
    t11 = <div className="pb-4 pt-6">{t3}{t8}{t10}</div>;
    $[26] = t10;
    $[27] = t3;
    $[28] = t8;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  return t11;
}